export default {
    searchSetting: {
        en: 'Search option by code...',
        ru: 'Поиск параметра по коду...',
    },
    name: {
        en: 'Name',
        ru: 'Название',
    },
    code: {
        en: 'Code',
        ru: 'Код',
    },
    saved: {
        en: 'Settings saved',
        ru: 'Настройки сохранены',
    },
    savingError: {
        en: (e) => `Saving error: ${e}`,
        ru: (e) => `Ошибка сохранения ${e}`,
    },
    codes: {
        status_visibility: {
            en: 'Status visibility control',
            ru: 'Управление видимостью статусов',
        },
        stats: {
            en: 'Statistics settings',
            ru: 'Настройка статистики',
        },
    },
    statusVisibilityControl: {
        invisibleFor: {
            en: 'Invisible for',
            ru: 'Невидим для',
        },
        visibleFor: {
            en: 'Visible for',
            ru: 'Видим для',
        },
    },
    statsConfig: {
        statuses: {
            en: 'Statuses config',
            ru: 'Настройка статусов',
        },
        notIncludedInStats: {
            en: 'Not included in stats',
            ru: 'Исключён из статистики',
        },
        includedInStats: {
            en: 'Included in stats',
            ru: 'Включён в статистику',
        },
    },
};
